"use client"

import React from "react"
import { Toaster as Sonner } from "sonner"
import { backgroundVariants, borderVariants } from "../../styles"
import { classNames } from "../../utils"
import { useToasts } from "./useToasts"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { toastYOffset, toastXOffset } = useToasts()

  return (
    <Sonner
      className={classNames("flex justify-end")}
      style={{ bottom: toastXOffset ? toastXOffset : 40, right: toastYOffset }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: classNames(
            // z-toast index
            "!z-[calc(var(--z-toast)+var(--z-index))] flex justify-center sm:justify-end",
            "rounded-lg font-sans shadow-xs",
            backgroundVariants({ background: "primary" }),
            borderVariants({ border: "border-1" }),
          ),
        },
      }}
      visibleToasts={5}
      {...props}
    />
  )
}

export { Toaster }
